if (!customElements.get("nss-tabs")) {
    customElements.define("nss-tabs", class NSSTabs extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                tablist: ".js-nss-tabs-tablist",
                tabs: ".js-nss-tabs-tab",
                tabpanels: ".js-nss-tabs-tabpanel"
            };


        }

        connectedCallback() {
            this.tablist = this.querySelector(this.selectors.tablist);
            this.tabs = Array.from(this.querySelectorAll(this.selectors.tabs));

            this.tabsHover = Array.from(this.querySelectorAll(`${this.selectors.tabs}[data-toggle="hover"]`));
            this.tabpanels = Array.from(this.querySelectorAll(this.selectors.tabpanels));
            this.orientation = this.tablist.getAttribute("aria-orientation");
            this.focusedTabIndex = 0;
            // Add keydown event listeners for tab navigation
            this.tablist.addEventListener("keydown", this.handleKeydown.bind(this));

            // Add click event listener to tabs using delegation
            this.tablist.addEventListener("click", this.handleTabClick.bind(this));
            this.tabsHover.forEach((tab) => {
                tab.addEventListener("mouseenter", this.handleTabHover.bind(this));
            });
        }

        activeFirst() {
            this.selectTab(0, false)
        }

        handleKeydown(e) {
            const horizontalKeys = {
                ArrowLeft: () => this.selectPreviousTab(),
                ArrowRight: () => this.selectNextTab(),
            };

            const verticalKeys = {
                ArrowUp: () => this.selectPreviousTab(),
                ArrowDown: () => this.selectNextTab(),
            };

            const commonKeys = {
                Home: () => this.selectFirstTab(),
                End: () => this.selectLastTab(),
            };

            // Prevent default for navigation keys
            if (e.key in commonKeys || (this.orientation === "vertical" && e.key in verticalKeys)) {
                e.preventDefault();
            }

            // Call corresponding handler
            const keyHandlers = {
                ...commonKeys,
                ...(this.orientation === "vertical" ? verticalKeys : horizontalKeys),
            };

            if (keyHandlers[e.key]) keyHandlers[e.key]();
        }

        handleTabClick(e) {
            const clickedTab = e.target.closest(this.selectors.tabs);
            if (clickedTab) {
                 if (clickedTab.getAttribute("data-toggle") == "both" && clickedTab.getAttribute("aria-selected") == "true") {
                    this.closeAll();
                } else {
                    const index = this.tabs.indexOf(clickedTab);
                    this.selectTab(index);
                }
            }
        }

        closeAll() {
            this.tabs.forEach((tab, i) => {
                tab.setAttribute("aria-selected", false);
                tab.setAttribute("tabindex", "-1");
            });
            this.tabpanels.forEach(panel => panel.classList.remove("is-visible"));
        }

        handleTabHover(e) {
            const clickedTab = e.target;
            const index = this.tabs.indexOf(clickedTab);
            this.selectTab(index);
        }

        selectTab(index, is_focused = false) {
            // Deactivate all tabs and hide all panels
            this.tabs.forEach((tab, i) => {
                const isSelected = i === index;
                tab.setAttribute("aria-selected", isSelected);
                tab.setAttribute("tabindex", isSelected ? "0" : "-1");
            });

            this.tabpanels.forEach(panel => panel.classList.remove("is-visible"));

            // Activate selected tab and panel
            const selectedTab = this.tabs[index];
            const panelId = selectedTab.getAttribute("aria-controls");
            this.querySelector(`#${panelId}`).classList.add("is-visible");
            if (is_focused) {
                selectedTab.focus();
                this.focusedTabIndex = index;
            }
        }

        selectPreviousTab() {
            const index = (this.focusedTabIndex - 1 + this.tabs.length) % this.tabs.length;
            this.selectTab(index, true);
        }

        selectNextTab() {
            const index = (this.focusedTabIndex + 1) % this.tabs.length;
            this.selectTab(index, true);
        }

        selectFirstTab() {
            this.selectTab(0);
        }

        selectLastTab() {
            this.selectTab(this.tabs.length - 1, true);
        }
    });
}